import { formatNumberByCountry, parseNumberByCountry } from "./formatNumbers";

/**
 * Las dos mitades de un campo de importe: cómo se escribe y cómo se lee.
 *
 * `InputNumber` de Ant Design necesita las dos. Con sólo `formatter`, el campo
 * **muestra** el importe con la convención del país pero lo **interpreta** con
 * la inglesa, que es la que trae por defecto. En un país donde el punto separa
 * los miles eso significa que teclear `27.800` --veintisiete mil ochocientos--
 * se lee como `27,8`.
 *
 * Y no es hipotético: el cierre de caja de Costa Rica tenía seis campos así.
 * El cajero copiaba el importe cobrado que la propia pantalla mostraba
 * ---`₡27.800,00000`--- lo pegaba en el digitado, y el cuadre salía con una
 * diferencia de `-27.772,20`.
 *
 * ## Por qué no se había visto
 *
 * Porque la aplicación nació en Ecuador, y **en Ecuador la convención inglesa
 * coincide con la local**: coma para los miles, punto para los decimales. El
 * campo funcionaba por casualidad. Sólo falla donde el punto separa los miles
 * —Costa Rica, Paraguay y Bolivia—, y de esos únicamente Costa Rica se estaba
 * mirando de cerca.
 *
 * ## Mientras se teclea no se toca lo que el cajero escribió
 *
 * `info.userTyping` es de Ant Design y dice si el cambio viene del teclado. En
 * ese caso se devuelve el texto tal cual: reformatear a media palabra mueve el
 * cursor y borra el separador que la persona acaba de poner.
 *
 * @param {object} country El país activo, con sus separadores.
 * @returns {{formatter: Function, parser: Function}} Para esparcir en el campo.
 */
export const campoDeMoneda = (country) => ({
  formatter: (value, info) =>
    info?.userTyping ? info.input : formatNumberByCountry(value, country, true),
  parser: (value) => parseNumberByCountry(value, country),
});
